import React from 'react';

import {useBreakpoint} from '@udemy/hooks';

import {TopicListCollectionDesktop} from './desktop/topic-list-collection-desktop.react-component';
import {TopicListCollectionMobile} from './mobile/topic-list-collection-mobile.react-component';
import {TopicListCollectionStore} from './topic-list-collection.mobx-store';
import styles from './topic-list-collection.module.less';

interface TopicListCollectionProps {
    store: TopicListCollectionStore;
}

export const TopicListCollection = (props: TopicListCollectionProps) => {
    const breakpoint = useBreakpoint();

    return (
        <>
            {(!breakpoint || breakpoint === 'sm') && (
                <div className={styles['mobile-only']}>
                    <TopicListCollectionMobile {...props} />
                </div>
            )}
            {breakpoint !== 'sm' && (
                <div className={styles['desktop-only']}>
                    <TopicListCollectionDesktop {...props} />
                </div>
            )}
        </>
    );
};
